/* eslint-disable no-unused-vars */
import { Alert, Box, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import ItemCardDefault from "pages/admin/components/ItemCardDefault";
import EditModal from "./components/EditModal";
import NewModal from "./components/NewModal";
import SearchAppBar from "components/CODXSearchAppBar/SearchAppBar";
import {
  getAllExercise,
  newExercise,
  deleteExercise,
  patchExercise,
} from "api/crud/hooks/useExercicios";
import { getAllTargetArea } from "api/crud/hooks/useGruposMusculares";
import HeaderExercicio from "./components/HeaderExercicio";
import TableExercicios from "./components/TableExercicios";
import { ItemCardExercicios } from "./components/ItemCardExercicios";
import SimpleBackdrop from "components/SimpleBackdrop";
import EmptyCard from "pages/admin/components/EmptyCard";

const PAGE_NAME = "Exercicios";

const Exercicios = () => {
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openText, setOpenText] = useState("");
  const [openErr, setOpenErr] = useState(false);
  const [openErrText, setOpenErrText] = React.useState("");
  const [open, setOpen] = useState(true);
  const [busca, setBusca] = useState("");
  const [items, setItems] = useState([]);
  const [gruposMusculares, setGruposMusculares] = useState([]);

  const handleClose = () => setOpenSuccess(false);
  const handleCloseErr = () => setOpenErr(false);

  useEffect(() => {
    GetItens();
    GetGruposMusculares();
  }, []);

  const GetGruposMusculares = async () => {
    try {
      const { status, message } = await getAllTargetArea();
      if (status === 200) {
        setGruposMusculares(message);
      } else {
        setGruposMusculares([]);
      }
    } catch (error) {
      setGruposMusculares([]);
      console.error('error GetGruposMusculares', error);
    }
  };

  const GetItens = async () => {
    try {
      const { status, message } = await getAllExercise();
      console.log('GetItens', message)
      setOpen(false)
      if (status === 200) {
        setItems(message);
      } else {
        setItems([]);
      }
    } catch (error) {
      setItems([]);
      console.error(error);
    }
  };

  const AddNewItem = async (payload) => {
    setOpen(true)
    try {
      const { status, message } = await newExercise(payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handleDeleteItem = async (id) => {
    setOpen(true)
    try {
      const { status, message } = await deleteExercise(id);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const handlePatchItem = async (id, payload) => {
    setOpen(true)
    try {
      const { status, message } = await patchExercise(id, payload);
      setRes(status, message);
    } catch (error) {
      console.error(error);
    }
    GetItens();
  };

  const setRes = (status, message) => {
    setOpen(true)
    if (status === 200) {
      setOpenText(message);
      setOpenSuccess(true);
    } else {
      setOpenErrText(message);
      setOpenErr(true);
    }
  }

  return (
    <>
      <SimpleBackdrop open={open} />
      <HeaderExercicio addFunction={AddNewItem} tittle={PAGE_NAME} NewModal={NewModal} gruposMusculares={gruposMusculares} />
      <Box component="main" sx={{ flex: 1, py: 6, px: 4, bgcolor: "#f2f2f2" }}>
        <SearchAppBar
          value={busca}
          onChange={(caracter) => {
            setBusca(caracter);
          }}
        />
        <br />
        {items ? (
          <TableExercicios
            itens={items}
            busca={busca}
            EditModal={EditModal}
            handleDeleteItem={handleDeleteItem}
            handlePatchItem={handlePatchItem}
            gruposMusculares={gruposMusculares}
          />
        ) : (
          <EmptyCard nome="Exercícios não encontrados" />
        )}
      </Box>
      <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          {openText}
        </Alert>
      </Snackbar>
      <Snackbar open={openErr} autoHideDuration={3000} onClose={handleCloseErr}>
        <Alert onClose={handleCloseErr} severity="error" sx={{ width: "100%" }}>
          {openErrText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Exercicios;
